export const BASE_URL = 'https://api.bakupower.az/api';
export const STORAGE_URL = 'https://api.bakupower.az/storage/';
export const X_APIKEY = 'bfcfc35c42b8054ec22c7366799f0ce4';
